import { useI18n } from '@change-corgi/core-react/i18n';

type Result = ModelHookResult<{
	breadcrumbItems: Array<{ label: string; href: string }>;
}>;

export function usePageBody(): Result {
	const { translate } = useI18n();

	return {
		data: {
			breadcrumbItems: [
				{ label: translate('fe.components.brand_pages_navbar.about'), href: '/about' },
				{ label: translate('fe.pages.open_platform.title'), href: '/about/open' },
			],
		},
	};
}
